export const REWARD_ENDPOINT = `https://${process.env.NEXT_PUBLIC_REWARD_GATEWAY_DOMAIN_NAME}`;
